import React, { useState } from 'react';

/**
 * Renders a framed product screenshot, or nothing if the image is missing.
 *
 * Screenshots live in public/screenshots/ and are generated by
 * scripts/capture-screenshots.js (logged-in app screens need a test account).
 * They are referenced as static public URLs — NOT webpack require() — so a
 * missing file produces no build warning; the <img> simply 404s and hides
 * itself via onError. This keeps the build clean before any capture is run.
 *
 * @param {string} name  screenshot filename without extension (e.g. 'app-generate')
 * @param {string} alt   descriptive alt text (translated by the caller)
 */
export default function ProductShot({ name, alt }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;

  const src = `${process.env.PUBLIC_URL || ''}/screenshots/${name}.png`;

  return (
    <div className="rounded-2xl overflow-hidden border border-border-primary shadow-xl bg-bg-primary">
      {/* Browser chrome */}
      <div className="flex items-center gap-1.5 px-4 py-3 bg-bg-tertiary border-b border-border-primary">
        <span className="h-3 w-3 rounded-full bg-red-400" />
        <span className="h-3 w-3 rounded-full bg-yellow-400" />
        <span className="h-3 w-3 rounded-full bg-green-400" />
      </div>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full block"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
